import {urlServices} from "./param-url.constants";

export const urlServicesPatientAdmin = {
  register: {
    one: urlServices.urlServicePatients + 'register-patients/',
    oneOnlyInfo: urlServices.urlServicePatients + 'register-patients/{patientId}/onlyInfo',
    list: urlServices.urlServicePatients + 'register-patients/{branchOfficeId}/list',
    listByOrganization: urlServices.urlServicePatients + 'register-patients/{organizationId}/list',
    //api/patients-administration/patients
    new: urlServices.urlServicePatients + 'register-patients',
    edit: urlServices.urlServicePatients + 'register-patients/',
    search: urlServices.urlServicePatients + 'register-patients/{branchOfficeId}/search',
    recordNumber: urlServices.urlServicePatients + 'register-patients/record-number',
    similarity: urlServices.urlServicePatients + 'register-patients/{branchOfficeId}/similarity',
    //api/patients-administration/register-patients/{branchOfficeId}/patient-ids
    patientIds: urlServices.urlServicePatients + 'register-patients/{branchOfficeId}/patient-ids',

    attentionPatientStatus: urlServices.urlServicePatients + 'register-patients/attention-patient-status/{patientId}',
  },
  admission: {
    //api/patients-administration/patient/admission
    save: urlServices.urlServicePatients + 'patient/admission',
    //api/patients-administration/patient/admission/{patientId}
    query: urlServices.urlServicePatients + 'patient/admission/',

    queryVisitId: urlServices.urlServicePatients + 'patient/admission/visitId/',
    //api/patients-administration/patient/admission/doctors/{unitId}/{specialityId}
    doctors: urlServices.urlServicePatients + 'patient/admission/doctors/',

    changeStatus: urlServices.urlServicePatients + 'patient/admission/change-status',
  },

  fusion: {
    //api/patients-administration/patient/fusion/list/{branchId}
    list: urlServices.urlServicePatients + 'patient/fusion/list/',
    //api/patients-administration/patient/fusion/filter/{branchId}
    filter: urlServices.urlServicePatients + 'patient/fusion/filter/',
    //api/patients-administration/patient/fusion/validate
    validate: urlServices.urlServicePatients + 'patient/fusion/validate',
    //api/patients-administration/patient/fusion/merge
    merge: urlServices.urlServicePatients + 'patient/fusion/merge',
    //api/patients-administration/patient/fusion/unlink/{fusionId}/{patientId}
    unlink: urlServices.urlServicePatients + 'patient/fusion/unlink/',
    //api/patients-administration/patient/fusion/fused-patient/{patientId}
    fusedPatient: urlServices.urlServicePatients + 'patient/fusion/fused-patient/',
  },

  availables: {
    //api/patients-administration/beds/rooms/{roomId}/availables/{sexId}/{birthDate}
    rooms: urlServices.urlServicePatients + 'beds/rooms/{roomId}/availables/',
    //api/patients-administration/beds/specialities/{specialityId}/rooms/{sexId}/{birthDate},
    specialityRooms: urlServices.urlServicePatients + 'beds/specialities/{specialityId}/rooms/'
  },

  registrer:{
    quick: urlServices.urlServicePatients + 'register-patients/quick',
    quicka: urlServices.urlServicePatients + 'register-patients/quick-a',
    quickb: urlServices.urlServicePatients + 'register-patients/quick-b'
  },

  registersVitalSigns:{
    update: urlServices.urlServicePatients + 'registers-vital-signs/update-registers',
    findBy: urlServices.urlServicePatients + 'registers-vital-signs/find-by-patient',
    findByDates: urlServices.urlServicePatients + 'registers-vital-signs/find-by-dates',
    save: urlServices.urlServicePatients + 'registers-vital-signs/save-registers'
  },

  catalogs: {
    //api/patients-administration/catalogs/sexes
    sexes: urlServices.urlServicePatients + 'catalogs/sexes',
    //api/patients-administration/catalogs/nationalities
    nationalities: urlServices.urlServicePatients + 'catalogs/nationalities',
    //api/patients-administration/catalogs/biological-sexes
    biologicalSexes: urlServices.urlServicePatients + 'catalogs/biological-sexes',
    //api/patients-administration/catalogs/genders
    genders: urlServices.urlServicePatients + 'catalogs/genders',
    //api/patients-administration/catalogs/indigenous-languages
    indLanguages: urlServices.urlServicePatients + 'catalogs/indigenous-languages',
    //api/patients-administration/catalogs/marital-status
    marital: urlServices.urlServicePatients + 'catalogs/marital-status',
    //api/patients-administration/catalogs/migrants
    migrants: urlServices.urlServicePatients + 'catalogs/migrants',
    //api/patients-administration/catalogs/schooling
    schooling: urlServices.urlServicePatients + 'catalogs/schooling',
    //api/patients-administration/catalogs/considered-indigenous
    conIndigenous: urlServices.urlServicePatients + 'catalogs/considered-indigenous',
    //api/patients-administration/catalogs/speaks-indigenous-language
    conIndigenousLang: urlServices.urlServicePatients + 'catalogs/speaks-indigenous-language',
    //api/patients-administration/catalogs/considered-afromexican
    conAfromexican: urlServices.urlServicePatients + 'catalogs/considered-afromexican',
    //api/patients-administration/catalogs/born-here
    bornHere: urlServices.urlServicePatients + 'catalogs/born-here',
    //api/patients-administration/catalogs/can-read-and-write
    readWrite: urlServices.urlServicePatients + 'catalogs/can-read-and-write',
    //api/patients-administration/catalogs/relationships
    relationships: urlServices.urlServicePatients + 'catalogs/relationships',
    //api/patients-administration/catalogs/affiliation-institutions
    affiliationInstitutions: urlServices.urlServicePatients + 'catalogs/affiliation-institutions',
    //api/patients-administration/catalogs/type-affiliations
    typeAffiliations: urlServices.urlServicePatients + 'catalogs/type-affiliations',
    //api/patients-administration/catalogs/gratuity
    gratuity: urlServices.urlServicePatients + 'catalogs/gratuity',
    //api/patients-administration/catalogs/insurers
    insurers: urlServices.urlServicePatients + 'catalogs/insurers',
    //api/patients-administration/catalogs/patient-origin
    patientOrigin: urlServices.urlServicePatients + 'catalogs/patient-origin',
    //api/patients-administration/catalogs/request-status
    requestStatus: urlServices.urlServicePatients + 'catalogs/request-status'

  },

  allergies: {

    //api/patients-administration/allergens
    allergens: urlServices.urlServicePatients + 'allergens',
    //api/patients-administration/allergies
    allergies: urlServices.urlServicePatients + 'allergies',
    //api/patients-administration/allergies-types
    allergiesTypes: urlServices.urlServicePatients + 'allergies-types',
    //api/patients-administration/medicines
    medicines: urlServices.urlServicePatients + 'medicines',
    //api/patients-administration/patients
    patients: urlServices.urlServicePatients + 'patients',
    //api/patients-administration/status-allergies
    statusAllergies: urlServices.urlServicePatients + 'status-allergies',
    //api/patients-administration/gravities
    gravityAllergies: urlServices.urlServicePatients + 'gravities',
    //api/patients-administration/allergies/patient/{id}
    allergiesFilterPatient: urlServices.urlServicePatients + 'allergies/patient'

  },

  visi_confirm: {
    getAll: urlServices.urlServicePatients + 'visit-consult',
    getDetails: urlServices.urlServicePatients + 'visit-consult/{visitConsultId}',
    validateCURP: urlServices.urlServicePatients + 'visit-consult/validation/curp/{branchOffice}/{doctorId}/{patientId}'
  },

  patientDiagnostic: {
    add: urlServices.urlServicePatients + 'patients-diagnostics/save-patients-diagnostics',
    getAll: urlServices.urlServicePatients + 'patients-diagnostics/{patientId}',
    put: urlServices.urlServicePatients + 'patients-diagnostics/update-patients-diagnostics',
    putStatus: urlServices.urlServicePatients + 'patients-diagnostics/update-status',
    delete: urlServices.urlServicePatients + 'patients-diagnostics/delete-patients-diagnostics/{patientDiagnosticId}',
    areSigned: urlServices.urlServicePatients + 'patients-diagnostics/are-signed/{patientId}',
    sing: urlServices.urlServicePatients + 'patients-diagnostics/sign/{patientId}',
  },

  medicalPresciptions: {
    getRecipes: urlServices.urlServicePatients + 'medicine-prescription/recipes/{patientId}',
    getRecipesActive: urlServices.urlServicePatients + 'medicine-prescription/recipes/{patientId}/active',
    getAll: urlServices.urlServicePatients + 'medicine-prescription/{patientId}/visitId/{visitId}',
    add: urlServices.urlServicePatients + 'medicine-prescription/{patientId}',
    updadate: urlServices.urlServicePatients + 'medicine-prescription/{prescriptionId}',
    delete: urlServices.urlServicePatients + 'medicine-prescription/{prescriptionId}',
    close: urlServices.urlServicePatients + 'medicine-prescription/{patientId}/close',
    closePre: urlServices.urlServicePatients + 'medicine-prescription/{patientId}/recipe/close',
    catFrecuency: urlServices.urlServicePatients + 'medicine-prescription/catalog/frequency',
  },
  medicalIntraPrescriptions: {
    getAll: urlServices.urlServicePatients + 'medicine-prescription/intrahospitals/{patientId}/visitId/{visitId}',
    suspend: urlServices.urlServicePatients + 'medicine-prescription/intrahospitals/{patientId}/suspend',
    add: urlServices.urlServicePatients + 'medicine-prescription/intrahospitals/{patientId}',
    updadate: urlServices.urlServicePatients + 'medicine-prescription/intrahospitals/{prescriptionId}',
    delete: urlServices.urlServicePatients + 'medicine-prescription/intrahospitals/{prescriptionId}',
  },

  triage: {
    //api/patients-administration/triages/ids/{triageId}
    id : urlServices.urlServicePatients + 'triages/ids/{branchId}/{triageId}',
    //api/patients-administration/triages/saves
    save: urlServices.urlServicePatients + 'triages/saves',
    //api/patients-administration/triages/signs/{triageId}/{doctorId}
    sign: urlServices.urlServicePatients + 'triages/signs/{triageId}/{doctorId}',
    //api/patients-administration/triages/history/{branchId}/{patientId}/{triageType}
    history: urlServices.urlServicePatients + 'triages/history/{branchId}/{patientId}/{triageType}'
  },

  requestAuxiliary: {
    add: urlServices.urlServicePatients + 'auxiliaries-request',
    getDetails: urlServices.urlServicePatients + 'auxiliaries-request/{historyId}',
    getHistory: urlServices.urlServicePatients + 'auxiliaries-request/history/{patientId}'
  },

  patientCensusUrgency: {
    attendAsing: urlServices.urlServicePatients + 'patients-census/attend-asign',
    attendPatient: urlServices.urlServicePatients + 'patients-census/attend-patient/{visitId}',
    filter: urlServices.urlServicePatients + 'patients-census'
  },

  persons: {
    getAll: urlServices.urlServicePatients + 'person',
    getPersonByUnit: urlServices.urlServicePatients + 'person/getPersonByUnit',
    getDoctors: urlServices.urlServicePatients + 'person/doctors',
    getById: urlServices.urlServicePatients + 'person/getPersonById/',
  },

  patienBeds: {
    patients: urlServices.urlServicePatients + 'beds/patients/{moduleId}/{specialityId}',
    bed: urlServices.urlServicePatients + 'beds/{bedId}',
    SetPatientBed: urlServices.urlServicePatients + 'beds/patient/set',
    releasePatient: urlServices.urlServicePatients + 'beds/patient/release/{bedId}',
    transferPatient: urlServices.urlServicePatients + 'beds/transfer',
    changeBedState: urlServices.urlServicePatients + 'beds/{bedId}/{stateId}',
  },

  internment:{
    accept: urlServices.urlServicePatients + 'internment/accept/{orderId}',
    byPatient: urlServices.urlServicePatients + 'internment/byPatient/{patientId}',
    cancel: urlServices.urlServicePatients + 'internment/cancel',
    save: urlServices.urlServicePatients + 'internment/save',
    search: urlServices.urlServicePatients + 'internment/search',
    byId: urlServices.urlServicePatients + 'internment/{id}',
  },
  emergencyDischarge: {
    getById: urlServices.urlServicePatients + 'high-emergency/{emeNotId}',
    getByVisitId: urlServices.urlServicePatients + 'high-emergency/visit/{visitId}',
    save: urlServices.urlServicePatients + 'high-emergency/{visitId}',
    edit: urlServices.urlServicePatients + 'high-emergency/{emeNotId}',
    addComorbidities: urlServices.urlServicePatients + 'high-emergency/{highEmerId}/comorbidities',
    deleteComorbidities: urlServices.urlServicePatients + 'high-emergency/comorbidities/{comId}',
    addInterconsultations: urlServices.urlServicePatients + 'high-emergency/{highEmerId}/interconsultations',
    deleteInterconsultations: urlServices.urlServicePatients + 'high-emergency/interconsultations/{intEspId}',
    addEmeProcedures: urlServices.urlServicePatients + 'high-emergency/{highEmerId}/eme-procedures',
    deleteEmeProcedures: urlServices.urlServicePatients + 'high-emergency/eme-procedures/{emeProcId}',
    addEmeAssingMedicinesIntra: urlServices.urlServicePatients + 'high-emergency/{highEmerId}/eme-assing-medicines-intra',
    deleteEmeAssingMedicinesIntra: urlServices.urlServicePatients + 'high-emergency/eme-assing-medicines-intra/{emeAssId}',
    sign: urlServices.urlServicePatients + 'high-emergency/{emeNotId}/sign',
  },

  prescription:{
      solutions:urlServices.urlServicePatients + 'prescription/solutions/{patientId}',
      suspend:urlServices.urlServicePatients + 'prescription/solutions/{patientId}/suspend',
      update: urlServices.urlServicePatients + 'prescription/solutions/{prescriptionSolutionId}'
  },

  nurce:{
    care:urlServices.urlServicePatients + 'prescription/nurce-care/{patientId}',
    suspend:urlServices.urlServicePatients + 'prescription/nurce-care/{patientId}/suspend',
    update: urlServices.urlServicePatients + 'prescription/nurce-care/{nurceId}'
  },

  diet:{
    values:urlServices.urlServicePatients + 'prescription/diet/{patientId}',
    suspend:urlServices.urlServicePatients + 'prescription/diet/{patientId}/suspend',
    update: urlServices.urlServicePatients + 'prescription/diet/{dietId}'
  },


  emeDiscHospHistory: {
    add :urlServices.urlServicePatients + 'emergency-hospitalization',
    getAll: urlServices.urlServicePatients + 'emergency-hospitalization/{pacientId}',
    getDetail: urlServices.urlServicePatients + 'emergency-hospitalization/detail/{emeDisHospId}',
    sign: urlServices.urlServicePatients + '/emergency-hospitalization/sign/{emeDisHospId}'
  },
  stayData: {
    getByEmeDisHosp: urlServices.urlServicePatients + 'stay-data/emeDisHosp/{emeDisHospId}',
    get: urlServices.urlServicePatients + 'stay-data/{stayDataId}',
    add: urlServices.urlServicePatients + 'stay-data/{emeDisHospId}',
    update: urlServices.urlServicePatients + 'stay-data/{stayDataId}',
    delete: urlServices.urlServicePatients + 'stay-data/{stayDataId}'
  },
  medicalDischargeComorbidities: {
    add: urlServices.urlServicePatients + 'medical-discharge/comorbidities/{emeDisHospId}',
    get: urlServices.urlServicePatients + 'medical-discharge/comorbidities/{disComId}',
    getByEmeDisHosp: urlServices.urlServicePatients + 'medical-discharge/comorbidities/emeDisHosp/{emeDisHospId}',
    update: urlServices.urlServicePatients + 'medical-discharge/comorbidities/{disComId}'
  },
  medicalDischargeProcedures: {
    add: urlServices.urlServicePatients + 'medical-discharge/procedure/{emeDisHospId}',
    get: urlServices.urlServicePatients + 'medical-discharge/procedure/{disProcId}',
    update: urlServices.urlServicePatients + 'medical-discharge/procedure/{disProcId}'
  },
  noteHighInjury: {
    add: urlServices.urlServicePatients + 'note-high-injury/{emeDisHospId',
    get: urlServices.urlServicePatients + 'note-high-injury/emeDisHosp/{emeDisHospId}',
    update: urlServices.urlServicePatients + 'note-high-injury/{injId}'
  },
  NoteHighHistGyne: {
    add: urlServices.urlServicePatients + 'note-high-hist-gyne/{emeDisHospId}',
    get: urlServices.urlServicePatients + 'note-high-hist-gyne/emeDisHosp/{emeDisHospId}',
    update: urlServices.urlServicePatients + 'note-high-hist-gyne/{ferWomId}'
  },
  productInformation: {
    add: urlServices.urlServicePatients + 'product-information/emeDisHosp/{emeDisHospId}',
    get: urlServices.urlServicePatients + 'product-information/emeDisHosp/{emeDisHospId}',
    update: urlServices.urlServicePatients + 'product-information/{proInfId}',
    delete: urlServices.urlServicePatients + 'product-information/{proInfId}'
  },
  psychiatricHospital: {
    add: urlServices.urlServicePatients + 'psychiatric-hospitals/{emeDisHospId}',
    get: urlServices.urlServicePatients + 'psychiatric-hospitals/{emeDisHospId}',
    update: urlServices.urlServicePatients + 'psychiatric-hospitals/{psyHosId}',
    delete: urlServices.urlServicePatients + 'psychiatric-hospitals/{psyHosId}'
  },


  treatments: {
    //api/patients-administration/treatments/days/{patientId}/{today}
    id : urlServices.urlServicePatients + 'treatments/days/{patientId}/{today}',
    //api/patients-administration/treatments/medicines/{patientId}/{today}/{type}/{origin}
    medicines : urlServices.urlServicePatients + 'treatments/medicines/{patientId}/{today}/{type}/{origin}',
    //api/patients-administration/treatments/search/
    history: urlServices.urlServicePatients + 'treatments/search',
    //api/patients-administration/treatments/administer
    administer: urlServices.urlServicePatients + 'treatments/administers',
    //api/patients-administration/treatments/administer
    multiple: urlServices.urlServicePatients + 'treatments/multiple',

  },
  'medical-record': {
    //api/patients-administration/medical-records/emr
    emr: urlServices.urlServicePatients + 'medical-records/emr',
    //api/patients-administration/medical-records/units/{branchId}
    units: urlServices.urlServicePatients + 'medical-records/units/',
  }
};
